// extracted by mini-css-extract-plugin
module.exports = {"root":"SidenavContainer_root__PaWcL"};